function hashSeed(value) {
  let hash = 0x811c9dc5;
  for (const character of String(value || "doctrina")) {
    hash ^= character.codePointAt(0);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

function hueToRgb(p, q, hue) {
  let value = hue;
  if (value < 0) value += 1;
  if (value > 1) value -= 1;
  if (value < 1 / 6) return p + (q - p) * 6 * value;
  if (value < 1 / 2) return q;
  if (value < 2 / 3) return p + (q - p) * (2 / 3 - value) * 6;
  return p;
}

function hslToRgb(hue, saturation, lightness) {
  const h = hue / 360;
  const s = saturation / 100;
  const l = lightness / 100;
  if (s === 0) return [l, l, l];
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  return [
    hueToRgb(p, q, h + 1 / 3),
    hueToRgb(p, q, h),
    hueToRgb(p, q, h - 1 / 3),
  ];
}

function linearChannel(channel) {
  return channel <= 0.04045
    ? channel / 12.92
    : ((channel + 0.055) / 1.055) ** 2.4;
}

export function relativeLuminance(rgb) {
  const [red, green, blue] = rgb.map(linearChannel);
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue;
}

export function contrastRatio(firstLuminance, secondLuminance) {
  const lighter = Math.max(firstLuminance, secondLuminance);
  const darker = Math.min(firstLuminance, secondLuminance);
  return (lighter + 0.05) / (darker + 0.05);
}

export function doctrineCoverPalette(seed) {
  const hash = hashSeed(seed);
  const hue = hash % 360;
  const saturation = 42 + ((hash >>> 8) % 29);
  const lightness = 28 + ((hash >>> 16) % 49);
  const backgroundLuminance = relativeLuminance(
    hslToRgb(hue, saturation, lightness),
  );
  const whiteContrast = contrastRatio(1, backgroundLuminance);
  const blackContrast = contrastRatio(0, backgroundLuminance);
  const useWhite = whiteContrast >= blackContrast;
  return {
    backgroundColor: `hsl(${hue} ${saturation}% ${lightness}%)`,
    color: useWhite ? "#ffffff" : "#000000",
    contrast: useWhite ? whiteContrast : blackContrast,
  };
}
